module.exports = __webpack_public_path__ + "img/bank-card-platinum.2e63634f.png";